import { render, staticRenderFns } from "./ReviewLhb.vue?vue&type=template&id=717ad2c6&scoped=true"
import script from "./ReviewLhb.vue?vue&type=script&lang=js"
export * from "./ReviewLhb.vue?vue&type=script&lang=js"
import style0 from "./ReviewLhb.vue?vue&type=style&index=0&id=717ad2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717ad2c6",
  null
  
)

export default component.exports